import * as Types from '../../../../gql/__generated/graphql.types';

import { SeoMetaDataFragment } from '../../../common/gql/__generated/seoMetadata.generated';
import { SeoMetaDataFragmentDoc } from '../../../common/gql/__generated/seoMetadata.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type AffiliateCollectionSeoQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AffiliateCollectionSeoQuery = (
  { __typename?: 'Query' }
  & { affiliateCollection?: Types.Maybe<(
    { __typename?: 'AffiliateCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'Affiliate' }
      & { seo?: Types.Maybe<(
        { __typename?: 'SeoMetadata' }
        & SeoMetaDataFragment
      )>, newBaseImage?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
      )> }
    )>> }
  )> }
);

export type AffiliateFieldsFragment = (
  { __typename?: 'Affiliate' }
  & Pick<Types.Affiliate, 'collectionName' | 'description' | 'products' | 'slug'>
  & { sys: (
    { __typename?: 'Sys' }
    & Pick<Types.Sys, 'id'>
  ), newBaseImage?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )> }
);

export type AffiliateCollectionBySlugQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  slug_in?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type AffiliateCollectionBySlugQuery = (
  { __typename?: 'Query' }
  & { affiliateCollection?: Types.Maybe<(
    { __typename?: 'AffiliateCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'Affiliate' }
      & AffiliateFieldsFragment
    )>> }
  )> }
);


export const AffiliateFieldsFragmentDoc = `
    fragment AffiliateFields on Affiliate {
  sys {
    id
  }
  collectionName
  description
  newBaseImage {
    url
    title
    width
    height
  }
  products
  slug
}
    `;
export const AffiliateCollectionSeoDocument = `
    query affiliateCollectionSeo($slug: String) {
  affiliateCollection(where: {slug: $slug}) {
    items {
      seo {
        ...SeoMetaData
      }
      newBaseImage {
        url
        title
        width
        height
      }
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useAffiliateCollectionSeoQuery = <
      TData = AffiliateCollectionSeoQuery,
      TError = unknown
    >(
      variables?: AffiliateCollectionSeoQueryVariables,
      options?: Omit<UseQueryOptions<AffiliateCollectionSeoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AffiliateCollectionSeoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AffiliateCollectionSeoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['affiliateCollectionSeo'] : ['affiliateCollectionSeo', variables],
    queryFn: graphqlFetcher<AffiliateCollectionSeoQuery, AffiliateCollectionSeoQueryVariables>(AffiliateCollectionSeoDocument, variables),
    ...options
  }
    )};

useAffiliateCollectionSeoQuery.getKey = (variables?: AffiliateCollectionSeoQueryVariables) => variables === undefined ? ['affiliateCollectionSeo'] : ['affiliateCollectionSeo', variables];


useAffiliateCollectionSeoQuery.fetcher = (variables?: AffiliateCollectionSeoQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<AffiliateCollectionSeoQuery, AffiliateCollectionSeoQueryVariables>(AffiliateCollectionSeoDocument, variables, options);

export const AffiliateCollectionBySlugDocument = `
    query affiliateCollectionBySlug($slug: String, $slug_in: [String]) {
  affiliateCollection(where: {slug: $slug, slug_in: $slug_in}) {
    items {
      ...AffiliateFields
    }
  }
}
    ${AffiliateFieldsFragmentDoc}`;

export const useAffiliateCollectionBySlugQuery = <
      TData = AffiliateCollectionBySlugQuery,
      TError = unknown
    >(
      variables?: AffiliateCollectionBySlugQueryVariables,
      options?: Omit<UseQueryOptions<AffiliateCollectionBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AffiliateCollectionBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AffiliateCollectionBySlugQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['affiliateCollectionBySlug'] : ['affiliateCollectionBySlug', variables],
    queryFn: graphqlFetcher<AffiliateCollectionBySlugQuery, AffiliateCollectionBySlugQueryVariables>(AffiliateCollectionBySlugDocument, variables),
    ...options
  }
    )};

useAffiliateCollectionBySlugQuery.getKey = (variables?: AffiliateCollectionBySlugQueryVariables) => variables === undefined ? ['affiliateCollectionBySlug'] : ['affiliateCollectionBySlug', variables];


useAffiliateCollectionBySlugQuery.fetcher = (variables?: AffiliateCollectionBySlugQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<AffiliateCollectionBySlugQuery, AffiliateCollectionBySlugQueryVariables>(AffiliateCollectionBySlugDocument, variables, options);
